export default function ProgressCircle({ progress }: Readonly<{ progress: number }>) {
  return (
    <div className="relative m-auto size-20 min-h-min">
      <svg className="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-zinc-800" strokeWidth="1"></circle>
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          className="stroke-current text-zinc-100"
          strokeWidth={1}
          strokeDasharray="100"
          strokeDashoffset={100 - progress}
          strokeLinecap="round"
        ></circle>
      </svg>
      <div className="absolute start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
        <span className="text-center text-sm text-zinc-100">{progress}%</span>
      </div>
    </div>
  )
}
